<template>
  <div class="the-navbar__user-meta flex items-center"></div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
    };
  },
  mounted() {},
  async created() {},
  computed: {},
  methods: {
    logout() {
      this.$router.push("/auth/login").catch(() => {});
    },
  },
};
</script>
